import UserRoles from './userRoles';

export default ({
  user,
  withAssignments,
  companyCode,
  requireCompanyCode,
}) => !withAssignments.length
  || user.role === UserRoles.SUPER_USER
  || withAssignments.some(requiredAssignment => user.allAssignments.includes(requiredAssignment.requiredPermission)
    || user.assignments.find(userAssignment => {
      const typeMatch = userAssignment.assignmentType === requiredAssignment.assignmentType;
      const companyCodeMatch = requireCompanyCode || userAssignment.assignment_code === companyCode;

      const permissionMatch = requiredAssignment.requiredPermission
        ? userAssignment.privileges.includes(requiredAssignment.requiredPermission)
        : true;

      return typeMatch && permissionMatch && companyCodeMatch;
    })
  );
